import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { error } from 'jquery';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/auth.service';
import { HttpService } from 'src/app/shared/services/http.service';
import { environment } from 'src/environments/environment.dev';

@Component({
  selector: 'app-auth',
  standalone: false,
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent implements OnInit{

  constructor(public appService:AppService, private router:Router, private httpService:HttpService, private authService:AuthService){}

  ngOnInit(): void {
    this.afterAuthFromAzure();
    // this.toGetUserDetails();
  }

  toGetUserDetails(){    
    this.appService.isLoading = true;
    let user = sessionStorage.getItem("SSO_user_data");
    let userData = user?JSON.parse(user):null;
    this.appService.selectedTheme = userData.unique_name.includes('dhl') ? true:false

    // console.log(`Calling API with: ${userData.unique_name}`); // Log API call

    this.httpService.getUserDetails(userData.unique_name)//userData.upn
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if(res.status === 400){
          this.appService.isLoggedIn=false;
        this.router.navigateByUrl('/page-not-found')
        this.httpService.openSnackBar( 'Please add email address! OR Contact Admin!' )
        return;
        }
        if (res.length > 0) {
          this.appService.isLoggedIn=true;
          this.appService.setUserDetails(res[0])
          sessionStorage.setItem("user-data",JSON.stringify(res[0]))
          this.appService.onCheckSetItem(true);
          this.appService.isLoading =true;
          this.authService.login(JSON.stringify(res[0]));

          setTimeout(() => {
            this.appService.selectedTheme = res[0].Email.includes('dhl') ?   false:true
            this.appService.isLoading =false;
            this.router.navigateByUrl('/home')
          }, 1000);
        }
        else{
          this.appService.isLoggedIn=false;
          this.router.navigateByUrl('/page-not-found')
          this.httpService.openSnackBar( 'Please add email address! OR Contact Admin!' )
        }
      },
      (error) => {
        console.error('API Call Error:', error); // Log full error
        this.appService.isLoggedIn=false;
          this.router.navigateByUrl('/page-not-found')
          this.httpService.openSnackBar('Please add email address! OR Contact Admin!' )
      })
  }

  private afterAuthFromAzure() {
    this.appService.isLoggedIn=false;
    let tokenForCall = sessionStorage.getItem("tokenRaw");
    const postOptions = {
      method: "POST",
      headers: {
        "Cookie": "buid=" + tokenForCall,
        "Authorization": 'Bearer ' + tokenForCall,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': "POST, PUT, GET, OPTIONS, DELETE",
        "Access-Control-Allow-Headers": "x-requested-with, authorization"
      },
      body: JSON.stringify({ token: tokenForCall })
    };

    this.appService.isLoading = true;
    
    fetch(this.appService.envVariable + "/auth", postOptions)
      .then(res => res.json())
      .then((res) => {        
        this.appService.isLoading = false;
        if(res){
          this.appService.isLoggedIn=true;
          const filteredKeys = ['aio', 'appid','family_name','given_name','name','unique_name','upn'];

          const filteredObject = Object.fromEntries(
            Object.entries(res)
              .filter(([key]) => filteredKeys.includes(key))
          );
          sessionStorage.setItem("SSO_user_data", JSON.stringify(filteredObject));
          sessionStorage.setItem("authToken",btoa(environment.TOKEN_FOR_SSO_AUTH))
          this.appService.onCheckSetItem(true)
          this.httpService.getCSRFToken().subscribe((res:any)=>{
            sessionStorage.setItem('csrf-token', res.token)
            this.toGetUserDetails();
          })
        }
        else{
          this.appService.isLoggedIn=false;
          this.router.navigateByUrl('/page-not-found')
          this.httpService.openSnackBar('Please add email address! OR Contact Admin!' )
          // this.router.navigateByUrl('*')
        }
       
        // this.appService.setSSOUserDetails(res);
        // this.onLoginBtn();
      })
      .catch(() => {
        this.appService.isLoggedIn=false;
        this.appService.isLoading = false;
        alert("Please check your credential..!")
        this.router.navigateByUrl('/page-not-found')
      })
  }

  onLoginBtn() {
    this.appService.isLoading = true;
    let user_SSO = sessionStorage.getItem("user_SSO_data");
    let userData = JSON.parse(user_SSO||"");
    
    // this.httpService.getUserDetails(userData.upn)
    //   .subscribe((res: any) => {
    //     this.appService.isLoading = false;
    //     if (res.length > 0) {
    //       sessionStorage.setItem("logedinUser", res[0].UserName);
    //       this.appService.userLoggedIn = true;
    //       this.appService.setUserDetails(res, res[0].UserName)
    //       this.router.navigateByUrl('/project')
    //     }
    //     else {
    //       this.router.navigateByUrl('/login')
    //       this.httpService.openSnackBar({ error: 'Please add email address! OR Contact Admin!' })
    //     }
    //   });
  }

}
